<template>
  <v-select
    :items="enumItems"
    v-model="model"
    :label="label"
    item-title="title"
    item-value="value"
    :clearable="clearable"
  />
</template>

<script setup lang="ts">
import { upperSnakeToTitleCase } from "@/api/util";
import { computed } from "vue";

// Props
const props = defineProps({
  enumObject: { type: Object, required: true },
  label: { type: String, default: "Select" },
  modelValue: [String, Number, Object],
  formatTitles: Boolean,
  clearable: Boolean,
});

const formatTitle = (title: string) => {
  return upperSnakeToTitleCase(title);
};

// Emits
const emit = defineEmits(["update:modelValue"]);

// Computed binding for v-model
const model = computed({
  get: () => props.modelValue,
  set: (val) => emit("update:modelValue", val),
});

// Convert enum or object to select items
const enumItems = computed(() =>
  Object.entries(props.enumObject).map(([key, value]) => ({
    title: props.formatTitles ? formatTitle(key) : key,
    value,
  })),
);
</script>
